import { OrganizationTypes } from '../../../../primary-record-types';
import React from 'react';
import Stack from '../../../v2BaseComponents/Stack';
import { Checkbox } from '../../../v2BaseComponents/Inputs';
import { clientRecordStatusTypeGuard } from '../../../../utils/clientRecordsUtil';

export type InvitationInputsOwnProps = {
    inputs: OrganizationTypes.InvitationDefinitionInputConsentCheckbox[];
    clientRecord: OrganizationTypes.OrganizationClientRecord;
};

export type InvitationInputsProps = InvitationInputsOwnProps;

const InvitationInputs: React.FC<InvitationInputsProps> = (props) => {
    const checkboxValue = !(
        clientRecordStatusTypeGuard.invited(props.clientRecord) ||
        clientRecordStatusTypeGuard.invitationRejected(props.clientRecord)
    );
    return (
        <Stack vertical fullWidth space={2} style={{ paddingLeft: 8 }}>
            {props.inputs.map((input, index) => (
                <Checkbox title={input.label} key={index} value={checkboxValue} isDisabled onChange={() => {}} />
            ))}
        </Stack>
    );
};

export default React.memo(InvitationInputs);
